// Shared admin error mapping. When any admin action fails with the backend's raw
// "Invalid CSRF token" (an expired session), surface a single friendly message
// consistently across the whole admin. Every other error passes through unchanged.
export const CSRF_EXPIRED_MESSAGE = "Session expired. Log out and log back in, then try again.";

export function adminErrorDetail(e, fallback = "Something went wrong. Please try again.") {
  const detail = e && e.response && e.response.data && e.response.data.detail;
  if (detail === "Invalid CSRF token") return CSRF_EXPIRED_MESSAGE;
  return typeof detail === "string" && detail ? detail : fallback;
}
